var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSocialDiscourse = function SvgSocialDiscourse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.101 0C18.664 0 24 5.484 24 11.996c0 6.511-5.328 11.992-11.899 11.992L0 24V11.79C0 5.282 5.531 0 12.101 0Zm.118 4.562a7.389 7.389 0 0 0-6.336 3.57 7.241 7.241 0 0 0-.149 7.219L4.4 19.608l4.797-1.074a7.417 7.417 0 0 0 8.133-1.39 7.247 7.247 0 0 0 1.738-7.996 7.377 7.377 0 0 0-6.84-4.586h-.008"
  })));
};
export default SvgSocialDiscourse;